import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var vitalsHasData = function (data) {
    return Object.values(data || {}).some(function (v) {
        return (typeof v === 'string' && v !== '') ||
            (typeof v === 'number' && v !== 0) ||
            (typeof v !== 'string' && typeof v !== 'number' && vitalsHasData(v));
    });
};
export var useVitalsHasData = function () {
    var vitalsWatch = useWatch({ name: 'objective.vitals' });
    var hasData = useMemo(function () { return vitalsHasData(vitalsWatch); }, [vitalsWatch]);
    return hasData;
};
